<template>
  <button type="button" class="catalog-filter-button" @click="$emit('click')">
    <svg>
      <use v-if="getSelectedFilters?.length > 0" xlink:href="#svg-filter-selected"></use>
      <use v-else xlink:href="#svg-filter"></use>
    </svg>

    <slot />
  </button>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
import { computed } from 'vue';

const { state, getters } = useStore();

const getSelectedFilters = computed(() => getters['catalog/getSelectedFilters']);
</script>

<style lang="scss" scoped>
.catalog-filter-button {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  cursor: pointer;
  padding: 8px 14px;
  background-color: var(--background-black);
  margin-right: 12px;
  @include point-md {
    font-size: 16px;
    padding: 12px 18px;
    margin-right: 16px;
  }
  @include point-lg {
    border: 1px solid var(--background-black);
    background-color: transparent;
    margin-right: 24px;
    color: var(--color-main);
  }
  svg {
    display: block;
    width: 18px;
    height: 18px;
    margin-right: 4px;
    fill: #fff;
    @include point-md {
      width: 20px;
      height: 20px;
    }
    @include point-lg {
      fill: #030304;
    }
  }
}
</style>
